import { render } from "./AddUpdateTargetUserForm.vue?vue&type=template&id=81383a08&scoped=true"
import script from "./AddUpdateTargetUserForm.vue?vue&type=script&lang=js"
export * from "./AddUpdateTargetUserForm.vue?vue&type=script&lang=js"

import "./AddUpdateTargetUserForm.vue?vue&type=style&index=0&id=81383a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81383a08"]])

export default __exports__